import { BridgeMode } from '@hg-com/xwc-js-bridge';
import { NativeIntegrationService } from 'src/core/services/native-integration.service';

export function wrapLinks(text: string) {
  // Regular expression to match https:// links
  const urlRegex = /(https:\/\/[^\s]+)/g;

  // Replace the links with <a> tags
  return text.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function formatNumber(num: number) {
  const fixed = num.toFixed(2);
  return parseFloat(fixed);
}

export async function hasBiometrics(nis: NativeIntegrationService) {
  return nis.spinTillReady().then(() => {
    if (nis.native.mode > BridgeMode.Mock) {
      return nis.basics.hasBiometricFeature$().then((x) => x.data ?? false);
    } else {
      return Promise.resolve(false);
    }
  });
}
